module.exports = __webpack_public_path__ + "static/media/Vologar_Hydrotech.80539fb6.jpg";